module.exports = __webpack_public_path__ + "media/reskin-images/img--women-at-workstation-072c994f.jpg";